import { UntypedFormGroup,UntypedFormBuilder } from "@angular/forms";
import { AppointmentsService } from "./../appointments.service";
import { DatePipe } from '@angular/common';
import { LoginService } from "../login.service";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { PatientsService } from "../patients.service";
import { SettingsService } from "../settings.service";
import { Subscription } from "rxjs";
@Component({
    selector: "app-appointment",
    templateUrl: "./appointment.component.html",
    styleUrls: ["./appointment.component.scss"],
    standalone: false
})
export class AppointmentComponent implements OnInit {
  @Output() closed = new EventEmitter<boolean>();
  @Input('event') event
  startOptionalsHours = [];
  appointmentForm:UntypedFormGroup
  showDeleteAlert=false
  errorUpdate
  examsTypes=[]
  examTypeSubscription:Subscription

  constructor(public appointmentService: AppointmentsService,private fb:UntypedFormBuilder,  private datePipe: DatePipe,public patientService:PatientsService,public ls:LoginService,public settings:SettingsService) {
    
  }

   ngOnInit() {
      // this.settings.getExams().then((data)=>{
      //   this.examsTypes =data.filter((exam)=>{
      //     return exam['users'].includes(Number(this.appointmentForm.get('UID').value))
      //   })
      // });
    this.resetAppointmentsForm();
      this.loadAppointmentsForm()
      this.generateTimes(this.appointmentService.startDate);
    
  }

  closeAppointmentModal(saveAppointment) {
    this.closed.emit(saveAppointment);
    
  }

  loadAppointmentsForm(){
    this.initialStartAppointmentHour();
    this.appointmentForm.get('duration').setValue(this.appointmentService.duration);
    this.appointmentForm.get('appointmentDate').setValue(this.appointmentService.startDate);
    this.appointmentForm.get('patientName').setValue(`${this.patientService.getPat().First} ${this.patientService.getPat().Last}` )
    this.appointmentForm.get('patientMobile').setValue(`${this.patientService.getPat().Mobile}` )
    this.appointmentForm.get('PID').setValue(this.patientService.getPat().PID)
    this.appointmentForm.get('UID').setValue(this.ls.doctor);
    if(this.event){
      // const examDetails={examName:this.event.examName,examType:this.event.examType,examTypeID:this.event.examTypeID}
      // const selectedExam = this.examsTypes.find(e => e.AutoIndex == this.event.examTypeID);
      this.appointmentForm.get('examTypeID').setValue(this.event.examTypeID,{emitEvent:false})
      this.appointmentForm.get('AutoIndex').setValue(this.appointmentService.AutoIndex)
      this.appointmentForm.get('UID').setValue(this.event.DocUID)
      this.appointmentForm.get('SendSMS').setValue(this.event.SendSMS)
      this.appointmentForm.get('ScheduleSMS').setValue(this.event.ScheduleSMS)   
      this.appointmentForm.get('comment').setValue(this.event.comment)   
    }

    

  }

  generateTimes(startDay) {
    const startHour = startDay.getHours();
    this.startOptionalsHours = [];
    for (let minute = 0; minute < 60; minute += 5) {
      let time = `${startHour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
      this.startOptionalsHours.push(time);
    }
  }

  initialStartAppointmentHour() {
    const startDate = this.appointmentService.startDate;
    if (startDate) {
      const hours = startDate.getHours().toString().padStart(2, "0");
      const minutes = startDate.getMinutes();
     const startHour = `${hours}:${minutes.toString().padStart(2, "0")}`; 
      this.appointmentForm.get('startHour').setValue(startHour) 
    }
  }

  resetAppointmentsForm(){
    this.appointmentForm = this.fb.group({
      AutoIndex:[''],
      appointmentDate:[''],
      startHour: [''], 
      patientName: [{value: '', disabled: true}], 
      patientMobile:[{value: '', disabled: true}],
      examTypeID: [null,{emitEvent: false}], 
      duration: [''], 
      comment: [null], 
      PID:[''],
      UID:[''],
      SendSMS:[true],
      ScheduleSMS:[true],
    });

    this.onExamTypeChange();
  }

  
  onExamTypeChange(): void {
    this.examTypeSubscription = this.appointmentForm.get('examTypeID').valueChanges.subscribe(selectedExam => {
      if (selectedExam) {
        const exam=this.examsTypes.find((exam)=>{
          return exam.AutoIndex == selectedExam;
        })
        this.appointmentForm.get('duration').setValue(exam.Length, {emitEvent: false});
      }
    });
  }

  
  getEventTypeDuration(type: string) {
    const typeColorMapper = this.examsTypes
    const exam = typeColorMapper.find(exam => exam.examName === type);
    return exam ? exam.Length : null; /**default value is blue of calendar */
  }


  saveAppointment(){
    console.log(this.appointmentForm.value,'valueeee')
    this.appointmentService.addEvent(this.appointmentForm.value).subscribe((data)=>{
    if (data['AutoIndex']){
      this.patientService.currentPatient=null
      this.closeAppointmentModal('reloadEvents')
    }
    })
  }

  
  async deleteAppointment() {
    try {
      // const result = await this.appointmentService.delete();
      // if (result) {
      //   this.closeAppointmentModal('reloadEvents');
      // }
    } catch (error) {
      console.error('Error during the deletion process:', error);
    }
  }

  
  async updateAppointment() {
    try {
      const result = await this.appointmentService.updateAppointment(this.appointmentForm.value);
      if (result['status']=='ok') {
        this.errorUpdate=false;
        this.closeAppointmentModal('reloadEvents');

      }
    } catch (error) {
      console.error('Error during the update Appointment:', error);
      // to do : display on screen error  update appointment
      this.errorUpdate=true
    }
  }

  ngOnDestroy(): void {
    if (this.examTypeSubscription) {
      this.examTypeSubscription.unsubscribe();
    }
  }

 
}
